import { useContainer } from '@/plugins/inversify';
import { IConfigService, IConfigServiceId } from '@/services/IConfigService';
import { AppConfigDto } from '@/types/webapi';
import { useAppStore } from '@geta/kolumbus-frontend/features/common';
import { merge } from 'lodash-es';
import { defineStore } from 'pinia';
import { ref, toValue } from 'vue';

export const useMainStore = defineStore('mainStore', () => {
    const container = useContainer();
    const configService = container.get<IConfigService>(IConfigServiceId);
    const appStore = useAppStore();
    const ready = ref(false);
    const isLoading = ref(false);
    const config = ref<AppConfigDto & { supportedLanguages: string[] }>({
        kolumbusWebsiteBaseUrl: '',
        privacyPolicyUrl: '',
        frequentlyAskedQuestionsUrl: '',
        travelPlannerWebsiteBaseUrl: '',
        webshopBaseUrl: '',
        supportedLanguages: ['no', 'en'],
        silentLoginEnabled: true,
        defaultCulture: 'no',
        travelCardOrderedMessageDays: 0,
        googleRecaptcha: {
            siteKey: ''
        },
        azureMonitorConnectionString: '',
        azureMonitorClientSideTrackingEnabled: false
    });

    async function loadConfig() {
        try {
            // fetch app config
            const _config = await configService.getConfig();
            config.value = merge(config.value, _config);

            return toValue(config);
        } catch (e) {
            registerError(e);

            return null;
        }
    }

    function registerError(error: any) {
        appStore.registerError(error);
    }

    return {
        ready,
        isLoading,
        config,
        loadConfig,
        registerError
    };
});
